import { useMediaQuery } from 'react-responsive';
import { isIOS, isTablet as isTabletDevice, isMobile as isMobileDevice } from 'react-device-detect';

export const useResponsive = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const isLargeDesktop = useMediaQuery({ minWidth: 1440 });

  // iOS specific detection
  const isIOSPhone = isIOS && isMobileDevice && !isTabletDevice;
  const isIOSTablet = isIOS && isTabletDevice;
  const isIOSDevice = isIOS;

  return {
    isMobile,
    isTablet,
    isDesktop,
    isLargeDesktop,
    isIOSPhone,
    isIOSTablet,
    isIOSDevice,
    // Helper for conditional rendering
    deviceType: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop',
    // Helper for iOS rendering
    iOSDeviceType: isIOSPhone ? 'ios-phone' : isIOSTablet ? 'ios-tablet' : 'non-ios'
  };
};
